import React from 'react';
import BaseDetailPage from '../../_CustomComponents/BaseDetailPage';
import ReactToPrint from "react-to-print";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import * as inspectionCrud from '../../../../crud/inspectionDefect.crud';
import * as fileCrud from '../../../../crud/file.crud';
import axios from 'axios';
import ActionModal from '../../_CustomComponents/ActionModal';
import ReplyDocument from './DocumentReply';
import DiaryDocument from './Document';
import { Navigate } from "react-router-dom";
import { ValidationSummary, ValidationGroup } from 'devextreme-react';
import moment from 'moment';
import Relations from '../../_CustomComponents/Relation/Relations';
import { FormattedMessage } from "react-intl";
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import PageToolbar from '../../_CustomComponents/PageToolbar';
import Common from '../../../../shared/common';
import { withDetailPageProps } from '../../../../shared/hoc/withDetailPageProps';
import NavigationBlocker from '../../../../partials/Tools/NavigationBlocker';
import EmailNotifications from '../../_CustomComponents/EmailNotifications';
import { Alert } from "react-bootstrap";
import { addDays } from 'date-fns';
import NotificationContext from '../../../../../notificationContext';

const initialState = {
    notification: null,
    files: null,
    showModal: false,
    saving: false,
    isChanged: false,
    relationCount: 0,
    //NEW REPLY STATES
    reply: null,
    replyFiles: null,
    isAwaitingReply: false,
    modalTitle: '',
    modalText: '',
    modalMode: '',
    overrideReplyParty: false,
    overrideSaveDraftReplyAllowed: false,
    overrideCommunicateReplyAllowed: false,
    relations: null,
    selectedClause: null,
    selectedReply: null
};

class DiaryDetailPage extends BaseDetailPage {
    constructor(props) {
        super(props);

        this.isRelationsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true' || process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true';
        this.printNotificationDivRef = React.createRef();
        this.printAcceptanceDivRef = React.createRef();
        this.validatorRef = React.createRef();
        this.validatorName = 'DiaryValidator';
        this.state = { ...initialState };
    }

    static contextType = NotificationContext;
    
    componentDidMount() {
        this.fetchInspectionDefect();
        this.fetchFiles();
        this.fetchReplyFiles();

    }

    componentWillUnmount() {
        this.context.updateNotificationContext({
            documentIsFinal: false,
            path: null,
            referenceId: null,
            referenceType: null,
            workflowGroupId: null,
            workflowId: null,
        });
    }


    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.params.notificationid !== prevprops.params.notificationid) {
            this.setState({ ...initialState }, () => {
                this.fetchInspectionDefect();
                this.fetchFiles();
                this.fetchReplyFiles();
            });
        }
    }
    getMailDescription = () => {
        return this.state.notification.replyactiondetail;
    }
    getSelectedTypeClauseDisplay = () => {
        return this.state.notification.replycomment;
    }
    fetchInspectionDefect = async () => {
        try {
            const { data: notification } = await inspectionCrud.getInspectionDefect(this.props.params.notificationid);


            if (notification.createdate) {
                notification.createdate = new Date(notification.createdate);
            }
            if (notification.inspectiondate) {
                notification.inspectiondate = new Date(notification.inspectiondate);
            }
            if (notification.notificationdate) {
                notification.notificationdate = new Date(notification.notificationdate);
            }
            try {
                if (notification.inspectiontime) {
                    notification.inspectiontime = moment(notification.inspectiontime, 'DD/MM/YYYY').toDate();
                    // var parts = defect.inspectiontime.split("/");
                    // defect.inspectiontime = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
                }
            } catch { }


            if (notification.draftreplydate) {
                notification.draftreplydate = new Date(notification.draftreplydate);
            }
            if (notification.replyrequireddate) {
                notification.replyrequireddate = new Date(notification.replyrequireddate);
            }
            const awaitingReply = (notification.showtasknotification === 1 && notification.replystatus === 'Awaiting Acceptance' && notification.isreplyrequired);
            const replyItem = {
                replystatus: notification.draftinspectionstatus,
                replyaction: notification.draftreplyaction,
                customfieldvalues: notification.customfieldvalues
            };
            const overrideProps = {
                overrideReplyParty: false,
                overrideSaveDraftReplyAllowed: false,
                overrideCommunicateReplyAllowed: false
            }
            let selectedClause = null;
            if (notification.replycomment) {
                const { fields } = this.props.workflowItem;
                selectedClause = fields.Type.clauses.find(c => c.display === notification.replycomment);
                if (selectedClause) {
                }
                else {
                    if (notification.showtasknotification !== 1) {
                        notification.replycomment = null;
                        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_CLAUSE_MISSING' }), { variant: 'warning', });
                    }
                }
            }
            if (this.props.workflowItem.replyEnabled) {
                if (selectedClause && selectedClause.overrideReplyingParty) {
                    overrideProps.overrideReplyParty = true;
                    overrideProps.overrideSaveDraftReplyAllowed = this.getOverrideReplyDraftAllowed(notification.replyingparty);
                    overrideProps.overrideCommunicateReplyAllowed = this.getOverrideReplyCommunicateAllowed(notification.replyingparty);
                }
            }
            this.setState({
                notification: notification,
                oldReplyRequiredDate: notification.replyrequireddate,
                reply: replyItem,
                isAwaitingReply: awaitingReply,
                saving: false,
                isChanged: false,
                relations: notification.relations,
                relationCount: Common.GetRelationCount(notification, this.props.accessibleWfIds),
                ...overrideProps
            }, () => { 
                this.props.setReference(this.state.notification.referenceid);
                this.context.updateNotificationContext({
                    documentIsFinal: notification.showtasknotification === 1,
                    path: this.props.location.pathname,
                    referenceId: this.props.params.notificationid,
                    referenceType: this.props.workflowItem.config.referenceType,
                    workflowGroupId: this.props.workflowGroupItem.id,
                    workflowId: this.props.workflowItem.id,
                });
            });

        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }




    }

    fetchFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, this.props.documentType)
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ files: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    fetchReplyFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, this.props.documentType + 'Reply')
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ replyFiles: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    printHandler = () => {
        this.printRef.handlePrint();
    }
    printReplyHandler = () => {
        this.printAcceptanceRef.handlePrint();
    }
    validateForm = () => {
        const validationResult = this.validatorRef.current.instance().validate();
        if (!validationResult.isValid) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_MISSING_FIELDS' }), { variant: 'warning', });
        }
        return validationResult.isValid && !this.state.saving;
    }
    showModal = (mode, postActionNavigateObj) => {
        let selectedClause = null;
        const { fields } = this.props.workflowItem;
        if (fields.Type.visible && this.state.notification.replycomment) {
            selectedClause = fields.Type.clauses.find(c => c.display === this.state.notification.replycomment);
        }
        if (mode === 'COMMUNICATE') {
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_COMMUNICATE_ITEM' }, { ITEM_NAME: this.props.title }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_COMMUNICATING' }, { ITEM_NAME: this.props.title }),
                    modalMode: mode,
                    postActionUrl: postActionNavigateObj
                });
            }
        }
        else if (mode === 'SAVE_DRAFT') {
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'DELETE_DRAFT') {
            this.setState({
                showModal: true,
                modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DELETE_DRAFT_NOTIFY' }),
                modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_DELETING' }),
                modalMode: mode,
            });
        }
        else if (mode === 'REPLY_DRAFT') {
            //show reply tab
            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_REPLY_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'REPLY_SEND') {
            let selectedReply = null;
            const { replyFields } = this.props.workflowItem;
            if (this.state.reply.replystatus && replyFields.ReplyStatus.replyOptions) {
                selectedReply = replyFields.ReplyStatus.replyOptions.find(c => c.field === this.state.reply.replystatus);
            }

            //show reply tab
            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SEND_REPLY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_SENDING' }),
                    modalMode: mode,
                    selectedClause,
                    selectedReply
                });
            }
        }
    }
    onModalResponse = (response, params) => {
        this.setState({ showModal: false, saving: response === 'OK' }, async () => {
            try {
                if (response === 'OK') {
                    const { fields } = this.props.workflowItem;
                    let selectedClause = null;
                    if (fields.Type.visible) {
                        selectedClause = fields.Type.clauses.find(item => item.display === this.state.notification.replycomment);
                        if (!selectedClause) {
                            console.log("Clause selection not found!");
                        }
                    }

                    if (this.state.modalMode === 'COMMUNICATE') {
                        const newNotification = { ...this.state.notification };
                        newNotification.createactions = params?.createactions;
                        newNotification.completeactions = params?.completeactions;
                        // newNotification.createby = this.props.contractUser.name;
                        newNotification.createbyid = this.props.contractUser.accountid;
                        // newNotification.notificationdatedisplay = moment().format('DD/MM/YYYY');
                        // newNotification.replystatus = 'Communicated';
                        newNotification.showtasknotification = 1;



                        if (!this.props.workflowItem.replyEnabled || (selectedClause && selectedClause.noReply)) {
                            //reply not possible
                            newNotification.isreplyrequired = false;
                            newNotification.replystatus = 'Communicated';
                            newNotification.replyrequireddate = null;
                            newNotification.replyrequireddatedisplay = null;
                        }
                        else if (this.props.workflowItem.replyEnabled) {
                            newNotification.isreplyrequired = true;
                            newNotification.replystatus = 'Awaiting Acceptance';

                            //ASSIGN REPLY REQUIRED DATE
                            if (selectedClause && selectedClause.applyReplyPeriod && selectedClause.hasOwnProperty("replyPeriod")) {
                                newNotification.replyrequireddate = moment(addDays(new Date(), selectedClause.replyPeriod)).toDate();
                            }
                            else if (this.props.workflowItem.replyPeriodOption === "ASKED_ON_COMMUNICATION_FORM") {
                                //DO NOTHING, "replyrequireddate" ALREADY SET ON FORM
                            }
                            else {
                                // Reply Period is set whats assigned on Workflow Setting
                                newNotification.replyrequireddate = moment(addDays(new Date(), this.props.workflowItem.replyPeriod)).toDate();
                            }

                            //ASSIGN RESUBMIT DAYS
                            newNotification.resubmitperiodindays = this.props.workflowItem.resubmitPeriod;
                            if (selectedClause && selectedClause.applyResubmitPeriod && selectedClause.hasOwnProperty("resubmitPeriod")) {
                                newNotification.resubmitperiodindays = selectedClause.resubmitPeriod;
                            }
                        }

                        const docBodyConfig = this.documentBodyConfig(newNotification, this.props.resources);
                        const docConfig = await this.documentConfig(newNotification, docBodyConfig, this.props.contractUser.name, false, null, null, this.props.workflowItem.form_NotifyCompanyName);
                        newNotification.pdfjsoncontent = JSON.stringify(docConfig);

                        this.saveNotification(newNotification, this.state.modalMode);


                    }
                    else if (this.state.modalMode === 'SAVE_DRAFT') {
                        const newNotification = { ...this.state.notification };
                        if ((params || {}).userid) {
                            newNotification.lastdraftednotifiedto = params.userid;
                        }
                        // newNotification.createby = this.props.contractUser.name;
                        newNotification.createbyid = this.props.contractUser.accountid;
                        // newNotification.notificationdatedisplay = moment().format('DD/MM/YYYY');
                        if (!this.props.workflowItem.replyEnabled || (selectedClause && selectedClause.noReply)) {
                            newNotification.replyrequireddate = null;
                            newNotification.replyrequireddatedisplay = null;
                        }
                        this.saveNotification(newNotification, this.state.modalMode, params ? params.userid : null);

                    }
                    else if (this.state.modalMode === 'DELETE_DRAFT') {
                        const inspection = { ...this.state.notification };
                        const inspectiondefectid = inspection.inspectiondefectid
                        this.deleteSiteDiaryDraft(inspectiondefectid);

                    }
                    else if (this.state.modalMode === 'REPLY_DRAFT') {
                        const reply = { ...this.state.reply };
                        const newNotification = { ...this.state.notification };
                        newNotification.draftinspectionstatus = reply.replystatus;
                        newNotification.draftreplyaction = reply.replyaction;
                        newNotification.draftreplystatus = 'Drafted';
                        newNotification.draftreplybyid = this.props.contractUser.accountid;
                        if ((params || {}).userid) {
                            newNotification.draftreplytoid = params.userid;
                        }
                        newNotification.draftreplydatedisplay = moment().format('DD/MM/YYYY');
                        for (let key in reply) {
                            if (key.startsWith("CF_")) {
                                newNotification[key] = reply[key];
                            }
                        }
                        this.saveNotification(newNotification, this.state.modalMode, (params || {}).userid);

                    }
                    else if (this.state.modalMode === 'REPLY_SEND') {
                        const reply = { ...this.state.reply };
                        if (!this.replyValidation(reply)) {
                            //FINAL REPLY FIELDS CHECK FAILED
                            throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_FIELDS_MISSING' }))
                        }
                        const newNotification = { ...this.state.notification };
                        newNotification.createactions = params?.createactions;
                        newNotification.completeactions = params?.completeactions;
                        newNotification.replystatus = reply.replystatus;
                        newNotification.replyaction = reply.replyaction;
                        newNotification.inspectionbyid = this.props.contractUser.accountid;
                        for (let key in reply) {
                            if (key.startsWith("CF_")) {
                                newNotification[key] = reply[key];
                            }
                        }
                        const docReplyBodyConfig = this.documentReplyBodyConfig(newNotification, this.props.resources);
                        let notifyCompanyName = this.props.workflowItem.form_ReplyCompanyName;
                        if (this.state.overrideReplyParty && this.props.workflowItem.form_CompanyLogo === 'PARTY') {
                            notifyCompanyName = Common.GetPartyOrUserCompanyName(this.props.contract, this.props.workflowItem.form_CompanyLogo, newNotification.replyingparty, this.props.userProfile)
                        }
                        const docReplyConfig = await this.documentConfig(newNotification, docReplyBodyConfig, this.props.contractUser.name, true, null, null, notifyCompanyName);
                        newNotification.pdfreplyjsoncontent = JSON.stringify(docReplyConfig);
                        this.saveNotification(newNotification, this.state.modalMode);
                    }


                }
            } catch (err) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                this.setState({ saving: false });
            }

        });
    }
    replyValidation = (reply) => {
        if (!reply.replystatus) { return false; }
        if (!["NO_REPLY_REQUIRED"].includes(reply.replystatus) && !reply.replyaction) { return false; }
        return true;
    }
    documentBodyConfig = (notification, resources) => {
        const { fields } = this.props.workflowItem;
        const config = [];
        if (fields.Subject.visible) {
            config.push({ label: fields.Subject.label, value: notification.replyactiondetail });
        }
        if (fields.Type.visible) {
            config.push({ label: fields.Type.label, value: notification.replycomment });
        }
        if (notification.isreplyrequired && fields.ResponseRequiredDate.visible) {
            config.push({ label: fields.ResponseRequiredDate.label, value: notification.replyrequireddate });
        }
        if (fields.Details.visible) {
            config.push({ label: fields.Details.label, value: notification.inspectiondetails, valueType: 'HTML', align: 'vertical' });
        }
        if (fields.StartDate.visible) {
            config.push({ label: fields.StartDate.label, value: notification.inspectiondate });
        }
        if (fields.EndDate.visible) {
            config.push({ label: fields.EndDate.label, value: notification.inspectiontime });
        }
        return config;
    }
    documentReplyBodyConfig = (notification, resources, replyOptions) => {
        let statusDisplay = "UNKNOWN";
        const { fields, replyFields } = this.props.workflowItem;
        const selectedReply = replyFields.ReplyStatus.replyOptions.find(opt => opt.field === notification.replystatus);

        if (selectedReply) {
            statusDisplay = selectedReply.display;
        }

        const config = [];
        if (fields.Subject.visible) {
            config.push({ label: fields.Subject.label, value: notification.replyactiondetail });
        }
        if (fields.Type.visible) {
            config.push({ label: fields.Type.label, value: notification.replycomment });
        }
        if (replyFields.ReplyStatus.visible) {
            config.push({ resource: "GENERAL.FORMS.FIELD.REPLY", value: statusDisplay });
        }
        if (!["NO_REPLY_REQUIRED"].includes(notification.replystatus)) {
            config.push({ resource: "GENERAL.FORMS.FIELD.REPLY_DETAIL", value: notification.replyaction, valueType: 'HTML', align: 'vertical' });
        }
        return config;
    }
    deleteSiteDiaryDraft = async (inspectionid) => {

        try {
            await inspectionCrud.deleteInspectionDraft(inspectionid);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_DELETED' }), { variant: 'success' });
            this.setState({ saving: false, navigateto: this.props.workflowItem.paths.listPath });

        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            this.setState({ saving: false });
        }

    }
    saveNotification = async (notification, action, notifyuserid) => {
        try {
            if (notification.inspectiondate) {
                notification.inspectiondatedisplay = moment(notification.inspectiondate).format('DD/MM/YYYY HH:mm:ss');
            }
            if (notification.inspectiontime) {
                notification.inspectiontime = moment(notification.inspectiontime).format('DD/MM/YYYY');
            }
            if (!notification.draftreplydatedisplay && notification.draftreplydate) {
                notification.draftreplydatedisplay = moment(notification.draftreplydate).format('DD/MM/YYYY');
            }
            notification.actioncode = action;
            notification.notifyuserlist = this.getNotifyUserListForUpdate(action, notifyuserid);
            Common.PropertyConversionsBeforeNoticeSaveRequest(notification, this.props.customFields, this.props.contractUsers);
            await inspectionCrud.updateInspectionDefect(notification);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.SAVED_SUCCESS' }), { variant: 'success', });
            if (this.state.postActionUrl) {
                this.setState({ isChanged: false, saving: false, navigateto: this.state.postActionUrl.pathname });
            }
            else {
                this.fetchInspectionDefect();
            }
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            this.setState({ saving: false });
        }
    }

    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        if (field) {
            if (field === "assetid") {
                this.setState({
                    notification: { ...this.state.notification, [field]: value, asset: { ...additionalData } },
                    isChanged: true
                });
            }
            else if (field === 'replycomment' && this.props.workflowItem.replyEnabled) {
                const { fields } = this.props.workflowItem;
                const selectedClause = fields.Type.clauses.find(item => item.display === value);
                let newReplyingParty = this.props.workflowItem.replyingParty;
                if (selectedClause && selectedClause.overrideReplyingParty) {
                    newReplyingParty = selectedClause.replyingParty;
                }
                this.setState({ notification: { ...this.state.notification, [field]: value, replyingparty: newReplyingParty }, isChanged: true });
            }
            else {
                this.state.notification[field] = value;
                if (!this.state.isChanged) {
                    this.setState({ isChanged: true });
                }
            }
        }
    }

    replyFieldChanged = (field, value, isDxReplyFormValid, isCheckBoxValue) => {
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        //this.setState({ notification: { ...this.state.notification, [field]: value } });
        if (field) {
            this.state.reply[field] = value;
            if (!this.state.isChanged) {
                this.setState({ isChanged: true });
            }
        }

    }
    renderToolbar = (documentIsFinal) => {
        const saveDisabled = (this.state.saving || this.state.showModal || this.state.fileUploading);
        return (
            <PageToolbar
                key={this.state.notification.version}
                documentIsFinal={documentIsFinal}
                saveDisabled={saveDisabled}
                isAwaitingReply={this.state.isAwaitingReply}
                actions={{
                    showModal: this.showModal,
                    onPrint: this.printHandler,
                    onPrintReply: this.printReplyHandler,
                }}
                workflowItem={this.props.workflowItem}
                match={this.props.match}
                customFieldValues={this.state.notification.customfieldvalues}
                referenceid={this.state.notification.referenceid}
                contract={this.props.contract}
                relationParams={{
                    subject: this.getMailDescription(),
                    assetid: this.state.notification.assetid
                }}
                overrideReplyParty={this.state.overrideReplyParty}
                overrideSaveDraftReplyAllowed={this.state.overrideSaveDraftReplyAllowed}
                overrideCommunicateReplyAllowed={this.state.overrideCommunicateReplyAllowed}
                notification={this.state.notification}
                selectedClausetypeDisplay={this.getSelectedTypeClauseDisplay()}
            />
        );
    }
    tabDocument = () => {
        return (
            <DiaryDocument
                {...this.props}
                printDivRef={this.printNotificationDivRef}
                fieldChanged={this.fieldChanged}
                notification={this.state.notification}
                files={this.state.files}

                notificationid={this.props.params.notificationid}
                saving={this.state.saving}
                onFileUploadFinish={() => this.setState({ fileUploading: false })}
                onFileUploadStart={() => this.setState({ fileUploading: true })}
            />
        );
    }
    tabRelations = () => {
        return (
            <Relations
                contractid={this.props.contract.contractid}
                workflowItem={this.props.workflowItem}
                workflowGroupItem={this.props.workflowGroupItem}
                notificationid={Number(this.props.params.notificationid)}
                relations={this.state.notification.relations}
                itemversion={this.state.notification.version}
                subject={this.state.notification.replyactiondetail}
                onCountChange={(count) => this.setState({ relationCount: count })}
                showTags={this.props.contract.specifictags?.length > 0}
                assetid={this.state.notification.assetid}
            />
        );
    }
    tabReply = (documentIsFinal) => {
        const { saveDraftReplyAllowed, communicateReplyAllowed } = this.props.workflowItem.userFilters.replyNotice;
        let canSeeReplyDraft = communicateReplyAllowed || saveDraftReplyAllowed;
        if (this.state.overrideReplyParty) {
            canSeeReplyDraft = this.state.overrideSaveDraftReplyAllowed || this.state.overrideCommunicateReplyAllowed;
        }
        if (!canSeeReplyDraft && this.state.isAwaitingReply) {
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                    <div style={{ width: '100%', maxWidth: '900px', margin: '20px' }}>
                        <Alert variant="warning" >
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_AWAITING_REPLY" values={{ ITEM_NAME: this.props.workflowItem.pageTitle }} />
                            </p>
                        </Alert>
                    </div>
                </div>
            )
        }
        else {
            return (
                <ReplyDocument
                    {...this.props}
                    isAwaitingReply={this.state.isAwaitingReply}
                    printDivRef={this.printAcceptanceDivRef}
                    fieldChanged={this.replyFieldChanged}
                    notification={this.state.notification}
                    reply={this.state.reply}
                    files={this.state.replyFiles}
                    notificationid={this.props.params.notificationid}
                    overrideReplyParty={this.state.overrideReplyParty}
                    overrideReplyPartyValue={this.state.notification.replyingparty}
                    saving={this.state.saving}
                    onFileUploadFinish={() => this.setState({ fileUploading: false })}
                    onFileUploadStart={() => this.setState({ fileUploading: true })}
                />
            )
        }
    }
    tabEmailNotification = () => {

        return (
            <EmailNotifications
                {...this.props}
                notificationDate={this.state.notification.notificationdate}
            />
        );

    };
    render() {
        if (!this.state.notification || !this.state.files || !this.state.replyFiles) {
            return (<PortletSpinner />);
        }
        const documentIsFinal = this.state.notification.showtasknotification === 1;
        const showReply = documentIsFinal && this.state.notification.isreplyrequired;
        if (!documentIsFinal && !this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed) {
            return (<Navigate replace to={this.props.workflowItem.paths.listPath} />)
        }

        return (
            <Portlet>
                <ReactToPrint
                    ref={el => (this.printRef = el)}
                    trigger={() => (<div style={{ display: 'none' }} ></div>)}
                    content={() => this.printNotificationDivRef.current}
                />
                <ReactToPrint
                    ref={el => (this.printAcceptanceRef = el)}
                    trigger={() => (<div style={{ display: 'none' }} ></div>)}
                    content={() => this.printAcceptanceDivRef.current}
                />
                <NavigationBlocker
                    when={(this.state.isChanged || this.state.saving)}
                    message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_UNSAVED' })}
                />
                {this.state.navigateto &&
                    (
                        <Navigate replace to={this.state.navigateto} state={(this.state.postActionUrl || {}).state} />
                    )
                }
                <PortletHeader
                    title={documentIsFinal ? this.props.workflowItem.pageTitle : this.props.intl.formatMessage({ id: "GENERAL.FORMS.DRAFT_TITLE" }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                    toolbar={this.renderToolbar(documentIsFinal)}
                />
                <PortletBody>
                    <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                        <div>
                            <ValidationSummary elementAttr={{ align: "right", paddingBottom: 50 }} id={this.validatorName}></ValidationSummary>
                        </div>
                        <TabPanel
                            ref={(ref) => this.tabPanel = ref}
                            width="100%"
                            deferRendering={false}
                            animationEnabled={true}
                            focusStateEnabled={true}
                            hoverStateEnabled={true}
                            swipeEnabled={false}>
                            <Item icon="file" title={this.props.title} render={this.tabDocument} />
                            <Item icon="rename" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_REPLY' })} render={showReply ? this.tabReply : null} visible={showReply} />
                            {
                                this.isRelationsEnabled && (
                                    <Item icon="share" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_RELATIONS' })} render={this.tabRelations} badge={this.state.relationCount > 0 ? this.state.relationCount : null} />
                                )
                            }
                            <Item
                                icon="bulletlist"
                                title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_EMAIL_NOTIFICATIONS' })}
                                render={documentIsFinal ? this.tabEmailNotification : null} visible={documentIsFinal}
                            />
                        </TabPanel>
                    </ValidationGroup>
                </PortletBody>
                <ActionModal
                    visible={this.state.showModal}
                    title={this.state.modalTitle}
                    text={this.state.modalText}
                    mode={this.state.modalMode}
                    onDialogResult={this.onModalResponse}
                    workflowItem={this.props.workflowItem}
                    overrideReplyParty={this.state.overrideReplyParty}
                    overrideReplyPartyValue={this.state.notification.replyingparty}
                    selectedClause={this.state.selectedClause}
                    selectedReply={this.state.selectedReply}
                />
            </Portlet>
        );
    }
}



export default withDetailPageProps(DiaryDetailPage);
